module.exports = __webpack_public_path__ + "media/19.ef848546.wav";